import React, { useEffect, useState, useCallback } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { IUsers } from "../interface/users";
// import { name, surname } from "react-lorem-ipsum";

interface IUserTable {
  title: string;
  data: IUsers[];
}

interface IColumn {
  id: "order" | "firstname-lastname" | "project" | "inprocess" | "complete";
  label: string;
  minWidth?: number;
  maxWidth?: number;
  align?: "right" | "center";
  format?: (value: number) => string;
}

const columns: IColumn[] = [
  { id: "order", label: "No.", maxWidth: 60 },
  { id: "firstname-lastname", label: "Name-Lastname", minWidth: 100 },
  {
    id: "project",
    label: "Project",
    minWidth: 100,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "inprocess",
    label: "Inprocess",
    minWidth: 100,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "complete",
    label: "Complete",
    minWidth: 100,
    align: "right",
    format: (value: number) => value.toFixed(2),
  },
];
interface IUsersData {
  filterText: string;
  data: IUsers[];
}
const useStyle = makeStyles((theme: Theme) => ({
  header: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    borderBottom: `solid 1px ${theme.palette.divider}`,
    "& .MuiCardHeader-action": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      height: theme.spacing(4.5),
    },
  },
  headerTitle: { fontFamily: "Montserrat-SemiBold" },
  cardHaft: { height: "100%" },
  textSearch: {
    margin: 0,
    // borderRadius: `${theme.spacing(5)}px !important`,
    "& .MuiInputBase-root": {
      borderRadius: `${theme.spacing(5)}px !important`,
    },
    "& .MuiFilledInput-underline:before": { borderBottom: "unset !important" },
    "& .MuiFilledInput-underline:after": { borderBottom: "unset !important" },
    "& input": {
      padding: `${theme.spacing(1) / 2}px ${theme.spacing(2)}px`,
      //   borderRadius: `${theme.spacing(5)}px !important`,
    },
  },
  cardContent: {
    height: `calc(100% - 45px)`,
    padding: 0,
    "&:last-child": { paddingBottom: 0 },
  },
  tableContainer: {
    maxHeight: "100%",
  },
}));

const UserTable = (props: IUserTable) => {
  const classes = useStyle();

  const { title, data } = props;

  const [tableData, settableData] = useState<IUsersData["data"]>([]);
  const [filterText, setfilterText] = useState<IUsersData["filterText"]>("");

  const initData = useCallback(async () => {
    const sortData = data.sort((a, b: any) => {
      return b.project - a.project;
    });

    settableData(sortData);
  }, [data]);
  useEffect(() => {
    if (data) {
      initData();
    }
  }, [initData, data]);

  const filterSubmit = (e: any) => {
    e.preventDefault();
    settableData(
      data.filter((list) =>
        list.first_name.toUpperCase().includes(filterText.toUpperCase())
      )
    );
  };

  useEffect(() => {
    const addDashboardlist = () => {
      if (!filterText && tableData && tableData.length !== data.length) {
        settableData(data);
      }
    };
    addDashboardlist();
  }, [tableData, data, filterText]);

  return (
    <Card className={classes.cardHaft}>
      <CardHeader
        title={
          <Typography variant="subtitle1" className={classes.headerTitle}>
            {title}
          </Typography>
        }
        action={
          //   <div>
          <form onSubmit={filterSubmit}>
            <TextField
              variant="filled"
              margin="dense"
              placeholder="Search"
              className={classes.textSearch}
              value={filterText}
              onChange={(e) => {
                setfilterText(e.target.value);
              }}
            />
          </form>
          //   </div>
        }
        className={classes.header}
      />
      <CardContent className={classes.cardContent}>
        <TableContainer className={classes.tableContainer}>
          <Table stickyHeader size="small" aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row: IUsers, index: number) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column: IColumn) => {
                      // const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.id === "order"
                            ? index + 1
                            : column.id === "firstname-lastname"
                            ? `${row.first_name} ${row.last_name}`
                            : row[column.id]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default UserTable;
